import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { startSpinner, stopSpinner } from "../../../redux/actions/spinnerActions";
import { ClioService } from "../../../api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TaskTable } from "./LitigationFunnelTaskTable";

interface Props {
  open: boolean;
  onClose: () => void;
  matterId: number;
}

const MySwal = withReactContent(Swal);

export const MatterDialog = ({ open, onClose, matterId }: Props) => {
    const [matter, setMatter] = useState<LitigationFunnelMatter | null>(null);
    const [tab, setTab] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(startSpinner());
        ClioService.getApiClioLitigationFunnelMatter(matterId).then((matter) => {
            setMatter(matter);
            dispatch(stopSpinner());
        }).catch(err => {
            MySwal.fire({
                icon: "error",
                title: <p className="title">Error loading data</p>,
            });
            dispatch(stopSpinner());
        });
    }, [matterId]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };
  
    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    function handleOpenInClio() {
        const clioUrl = `https://app.clio.com/nc/#/matters/${matterId}`;
        window.open(clioUrl, "_blank", "noopener,noreferrer");
    }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogContent>
        {matter ? (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    marginTop: 1,
                    textAlign: 'left',
                }}
            >
                <Typography variant="h5" sx={{ textWrap: 'auto'}}>
                    {matter.matter.display_number}
                </Typography>

                <Box>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tab} onChange={handleTabChange} aria-label="Task Tabs">
                            <Tab label="In Progress" {...a11yProps(0)} />
                            <Tab label="Completed" {...a11yProps(1)} />
                        </Tabs>
                    </Box>

                    <TaskTable 
                        value={tab} 
                        index={0} 
                        tasks={matter.funnelTasks.filter(t => t.task.status !== "complete")} 
                    />

                    <TaskTable
                        value={tab}
                        index={1}
                        tasks={matter.funnelTasks.filter(t => t.task.status === "complete")} 
                    />
                </Box>
                
            </Box>
        ): (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300 }}>
                <CircularProgress size={24} thickness={4} />
            </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
            variant="contained"
            color="primary"
            onClick={handleOpenInClio}
        >
          Open Clio
        </Button>
        <Button 
            onClick={onClose}
            variant="contained"
            color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
